import http from "../axios";

let apiV1EmailCampaigns = {
	baseUrl: '/api/v1/email-campaigns',
	unsubscribe: async (token) => {
		return await http.patch(`${apiV1EmailCampaigns.baseUrl}/unsubscribe/${token}`);
	},
};

export { apiV1EmailCampaigns };
